import { ChangeDetectionStrategy, Component } from '@angular/core';
import moment from 'moment';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    readonly year: string = moment().format('yyyy');
}
